import React from "react";
import { Dropdown } from "antd";
import { userNameEmpId } from "../utils/userDetails";
import { HiOutlineUserCircle } from "react-icons/hi2";

// const handleLogOut = () => {
//   window.location.href = "http://stagingapps.spanidea.com/login";
// };

const items = [
  {
    key: "1",
    label: <span style={{ cursor: "default" }}>{userNameEmpId.name}</span>,
  },
  {
    key: "2",
    label: <span style={{ cursor: "default" }}>{userNameEmpId.empId}</span>,
  },
];

const User = () => {
  return (
    <span>
      <Dropdown
        menu={{
          items,
        }}
        trigger={["hover"]}
        placement="bottom"
        overlayStyle={{ minWidth: "150px" }}
      >
        <HiOutlineUserCircle
          style={{
            cursor: "pointer",
            color: "#FFFFFF",
            width: "28px",
            height: "28px",
            display: "flex",
            spaceBetween: "center",
          }}
        />
      </Dropdown>
    </span>
  );
};

export default User;
